import { useMemo, useCallback } from "react";
import { useSharedState, useSearchStatus } from "hooks";
import { StatusType } from "data/Types";
import { searchService } from "services";

const useSearchQuery = (abort = true) => {
  const [search, setSearch] = useSharedState(searchService.search$);
  const [status, setStatus] = useSearchStatus();
  const setSearchAndAbort = useCallback(
    (search) => {
      setSearch(search);
      setStatus(status | StatusType.Modified);
      if (status & StatusType.Querying) {
        console.warn("Aborting... new user input");
        searchService.abort(true);
      }
    },
    [setSearch, status, setStatus]
  );
  return useMemo(() => [search, abort ? setSearchAndAbort : setSearch], [
    search,
    setSearchAndAbort,
    setSearch,
    abort,
  ]);
};

export { useSearchQuery };
